import * as Yup from 'yup';

export const formSchema = [
  {
    fieldName: 'nationalityId',
    type: 'Dropdown',
    label: 'Specify your nationality',
  },
  {
    fieldName: 'citizenshipId',
    type: 'Dropdown',
    label: 'Specify your citizenship',
  },
  {
    fieldName: 'passportFirstName',
    type: 'TextareaAsInput',
    label: 'First name as in passport',
  },
  {
    fieldName: 'passportLastName',
    type: 'TextareaAsInput',
    label: 'Last name as in passport',
  },
];

export const validationSchema = Yup.object().shape({
  passportFirstName: Yup.string()
    .required('This field is required')
    .matches(/^(?=.*[a-zA-Zа-яА-Я])/, 'First name must contain at least one letter')
    .matches(/^[a-zA-Zа-яА-Я ,.'-]+$/, 'First name must contain only letters'),
  passportLastName: Yup.string()
    .required('This field is required')
    .matches(/^(?=.*[a-zA-Zа-яА-Я])/, 'Last name must contain at least one letter')
    .matches(/^[a-zA-Zа-яА-Я ,.'-]+$/, 'Last name must contain only letters'),
});
